<template>
    <div>
        <modal
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            btn-save-title="Сохранить"
            :btn-save-classes="['cabinet-btn--blue']"
            title="Добавить бланк договора"
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            <div class="cabinet-form-group">
                <div class="app-modal__subtitle subtitle2">Загрузите файл</div>
                <p class="pt-2 caption">
                    Загружаемый файл может быть в формате .doc, .docx или .rtf,
                    а размер не должен превышать 32 Мб.
                </p>
                <div
                    class="cabinet-settings-documents__item-info flex flex-align-center"
                >
                    <label
                        class="custom-file-upload custom-file-upload--line subtitle2 mt-0"
                    >
                        <input
                            type="file"
                            accept=".rtf,.doc,.docx"
                            @change="setFile($event)"
                        />
                        Загрузить
                    </label>
                    <span v-if="file" class="ml-3">{{
                        file.target.files[0].name
                    }}</span>
                </div>
                <div
                    v-if="$v.file.$invalid && $v.file.$dirty"
                    class="cabinet-form-group__error caption"
                >
                    Пожалуйста, загрузите файл
                </div>
                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label required"
                        >Название документа</label
                    >
                    <input
                        id="to"
                        v-model="title"
                        type="text"
                        class="cabinet-form-group__input cabinet-form-group__input--big mw-100"
                        :class="{ error: $v.title.$dirty && $v.title.$invalid }"
                    />
                    <div class="cabinet-form-group__note caption">
                        Отображается другим пользователям
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import { mapState, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'

const validations = {
    title: {
        required
    },
    file: {
        required
    }
}

export default {
    name: 'DocsModal',
    components: { Modal },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            title: null,
            file: null
        }
    },
    computed: {
        ...mapState('supplierDocs', ['error'])
    },
    validations,
    methods: {
        setFile(e) {
            this.file = e
        },
        closeModal() {
            this.$emit('closeModal')
        },
        async saveModal() {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                if (this.loading) return

                this.loading = true

                try {
                    let sendFileContent = {
                        title: this.title,
                        event: this.file,
                        type: 'contract'
                    }
                    this.file = null
                    this.title = null
                    this.$v.$reset
                    await this.$emit('sendDocument', sendFileContent)
                } catch (e) {
                    this.$notify({
                        title: this.error,
                        type: 'error'
                    })
                }
                this.loading = false
            } else {
                this.$notify({
                    title: 'Форма заполнена некорректно',
                    type: 'error'
                })
            }
        }
    }
}
</script>
